import { IConfigObject, IReactiveConfigurationDataSource } from '../types';

import { createStaticDataSource } from './staticDataSource';

const dataSources: { [key: string]: IReactiveConfigurationDataSource<IConfigObject> } = {};

const emptyDataSource = createStaticDataSource({});

export function setDataSource(name: string, dataSource: IReactiveConfigurationDataSource<IConfigObject>): void {
  dataSources[name] = dataSource;
}

export function getDataSource<T extends IConfigObject = IConfigObject>(
  name: string
): IReactiveConfigurationDataSource<T> {
  if (!dataSources.hasOwnProperty(name)) {
    throw new Error('dataSource not set yet');
  }
  return dataSources[name] as IReactiveConfigurationDataSource<T>;
}

export function tryGetDataSource<T extends IConfigObject = IConfigObject>(
  name: string
): IReactiveConfigurationDataSource<T> {
  if (!dataSources.hasOwnProperty(name)) {
    return emptyDataSource as IReactiveConfigurationDataSource<T>;
  }
  return dataSources[name] as IReactiveConfigurationDataSource<T>;
}
